import React from 'react';
const _ = require("lodash");
const { compose, withProps, lifecycle } = require("recompose");
const {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} = require("react-google-maps");
const { SearchBox } = require("react-google-maps/lib/components/places/SearchBox");

export const MapMarkers = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA4jjZnsw8iYo3eDeZROTP-S63t1wfPYyo&v=3&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
    
  }),
  lifecycle({
    componentWillMount() {
      const refs = {}
      
      this.setState({
        bounds: null,       
        center: { lat: 13.7734283, lng: 100.57383099999993 },
       
        onBoundsChanged: _.debounce(
          () => {
           
         
            let { onBoundsChange ,center} = this.props
            this.setState({
              bounds: refs.map.getBounds(),
              center: center
            })
            console.log("props"+ JSON.stringify(center));
            if (onBoundsChange) {
              onBoundsChange(refs.map)
            }
          },
          100,
          { maxWait: 500 }
        ),
        onMapMounted: ref => {
          refs.map = ref;
          console.log(ref);
        },
        /*onBoundsChanged: () => {
          this.setState({
            bounds: refs.map.getBounds(),
            center: refs.map.getCenter(),
          })
        },*/
        
      })
    },
  }),
  withScriptjs,
  withGoogleMap,
)(props =>
 
  <GoogleMap
    resetBoundsOnResize={true}
    ref={props.onMapMounted}
    defaultZoom={15}
    zoom={props.zoom}
    defaultCenter={{ lat: 13.7734283, lng: 100.57383099999993 }}
    center={props.center}
    onBoundsChanged={props.onBoundsChanged}
    
  >
  

    <Marker  position={props.marker} icon="assets/map/c3leng-marker.png"/>    
    {props.markers.map((marker, index) =>
      <Marker key={index} label={marker.label} position={marker} onClick={props.onMarkerClicked} />      
    )}
    

  </GoogleMap>
);

